import { EstimateResponse } from '@/types/estimates/EstimateResponse';

export type AgencyFlexibilityVisibilityFlag =
  | 'showQuoteName'
  | 'showSummaryAndImportantPoints'
  | 'showPriceIncludesExcludes'
  | 'showModificationCancellationConditions';

type FlexibilityEstimate = Pick<
  EstimateResponse,
  | 'allowAgencyModification'
  | 'viewContext'
  | AgencyFlexibilityVisibilityFlag
>;

const isFlexibilityFlagDisabled = (
  estimate: FlexibilityEstimate,
  flag: AgencyFlexibilityVisibilityFlag,
): boolean => estimate.allowAgencyModification === true && estimate[flag] === false;

/** Hidden on the client link only (TO/agency still see the content, muted). */
export const shouldHideAgencyFlexibilityContent = (
  estimate: FlexibilityEstimate,
  flag: AgencyFlexibilityVisibilityFlag,
): boolean =>
  isFlexibilityFlagDisabled(estimate, flag) &&
  estimate.viewContext === 'CLIENT_LINK';

/** Shown in gray on TO and agency views when the client must not see it. */
export const shouldMuteAgencyFlexibilityContent = (
  estimate: FlexibilityEstimate,
  flag: AgencyFlexibilityVisibilityFlag,
): boolean =>
  isFlexibilityFlagDisabled(estimate, flag) &&
  (estimate.viewContext === 'TO_AUTHENTICATED' ||
    estimate.viewContext === 'AGENCY_LINK');

/** Skip circuit fallbacks on the client link when the TO hid this block. */
export const shouldMaskAgencyFlexibilityFieldForViewer = (
  estimate: FlexibilityEstimate,
  flag: AgencyFlexibilityVisibilityFlag,
): boolean => shouldHideAgencyFlexibilityContent(estimate, flag);
